import React from 'react';
import Block from '../static/js/blog_section';
//import "../static/css/Blog.css"

function Blog() {
    // *! very important
    // *? WHAT?
    return(
        <div className='blog_body'>
            <Block/>
        </div>
    );
}

export default Blog;